export const targetContainsClickEvent = (event, target) => {
    if (event?.target && target) {
        return event.target === target || target.contains(event.target);
    }

    return false;
};
